'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _trigger = require('../trigger');

var _trigger2 = _interopRequireDefault(_trigger);

var _checkbox = require('../checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _data = require('../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

//TODO Icon 引入

// React Stateless
var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(_ref) {
  var prefixCls = _ref.prefixCls;
  var style = _ref.style;
  var onClick = _ref.onClick;
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: prefixCls + '-filter-dropdown', style: style, onClick: onClick },
    children
  );
};
FilterDropdownMenuWrapper.propTypes = {
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.any
};

var FilterMenu = (_temp = _class = function (_Component) {
  _inherits(FilterMenu, _Component);

  function FilterMenu(props) {
    _classCallCheck(this, FilterMenu);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FilterMenu).call(this, props));

    _initialiseProps.call(_this);

    var column = props.column;

    var visible = false;
    //如果是自定义的筛选，则允许定义下拉初始时是否显示
    if ('filterDropdown' in column) {
      visible = column.filterDropdownVisible === true;
    }

    _this.state = {
      selectedKeys: props.selectedKeys,
      keyPathOfSelectedItem: {}, // 记录所有有选中子菜单的祖先菜单
      visible: visible
    };
    return _this;
  }

  _createClass(FilterMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // 点击了控件内区域以及弹出层之外  关闭弹窗
      this.removeMenu = function (e) {
        var _refs = _this2.refs;
        var container = _refs.container;
        var trigger = _refs.trigger;

        if (_this2.state.visible && !(0, _reactDom.findDOMNode)(container).contains(e.target) && !trigger.getPopupDOMNode().contains(e.target)) {
          _this2.setState({ visible: false });
        }
      };
      window.addEventListener('click', this.removeMenu, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var selectedKeys = nextProps.selectedKeys;
      var column = nextProps.column;
      //如果是自定义筛选，且传入了下拉是否显示

      if ('filterDropdown' in column && 'filterDropdownVisible' in column) {
        this.setState({
          visible: column.filterDropdownVisible
        });
      }
      this.setState({ selectedKeys: selectedKeys });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.removeMenu, false);
    }

    /**
     * 更新当前选中的筛选条件
     * @param key 当前选中的筛选条件
     */


    /**
     * 点击筛选按钮
     * @param visible 将要切换的状态
     */

  }, {
    key: 'confirmFilter',
    value: function confirmFilter(selectedKeys) {
      selectedKeys = selectedKeys || this.state.selectedKeys;
      if (selectedKeys !== this.props.selectedKeys) {
        this.props.confirmFilter(this.props.column, selectedKeys);
      }
    }
  }, {
    key: 'renderMenuItem',
    value: function renderMenuItem(item) {
      var column = this.props.column;

      var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
      var checked = this.state.selectedKeys.indexOf(item.value.toString()) >= 0;
      return _react2.default.createElement(
        'li',
        { key: item.value, onClick: this.setSelectedKeys.bind(this, item.value.toString()), className: checked ? 'active' : '' },
        multiple ? _react2.default.createElement(_checkbox2.default, { checked: checked, size: 'small', label: item.text }) : _react2.default.createElement(
          'a',
          null,
          item.text
        )
      );
    }
  }, {
    key: 'renderMenus',
    value: function renderMenus(items) {
      var _this3 = this;

      return items.map(function (item) {
        if (item.children && item.children.length > 0) {
          var _ret = function () {
            var _state = _this3.state;
            var keyPathOfSelectedItem = _state.keyPathOfSelectedItem;
            var selectedKeys = _state.selectedKeys;

            var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
              return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
            });
            var column = _this3.props.column;

            var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
            var subMenuCls = containSelected ? _this3.props.prefixCls + '-dropdown-submenu-contain-selected' : '';
            var checked = selectedKeys.indexOf(item.value.toString()) >= 0;
            var key = item.value.toString();
            return {
              v: _react2.default.createElement(
                'li',
                { title: item.text, className: subMenuCls, onClick: _this3.handleMenuItemClick.bind(_this3, key), key: key },
                column.allSelectable && multiple && _react2.default.createElement(_checkbox2.default, { checked: checked, onClick: _this3.setSelectedKeys.bind(_this3, key) }),
                _react2.default.createElement('i', { className: _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-angle-right' }),
                _react2.default.createElement(
                  'span',
                  null,
                  item.text
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  item.children.map(function (child) {
                    return _this3.renderMenuItem(child);
                  })
                )
              )
            };
          }();

          if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        }
        return _this3.renderMenuItem(item);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this,
          _classNames;

      var _props = this.props;
      var column = _props.column;
      var locale = _props.locale;
      var prefixCls = _props.prefixCls;
      var getPopupContainer = _props.getPopupContainer;
      var visible = this.state.visible;

      var multiple = 'filterMultiple' in column ? column.filterMultiple : true;

      var menus = column.filterDropdown ? (0, _data.getComponent)(column.filterDropdown, {
        confirm: this.handleConfirm,
        cancel: this.handleClearFilters
      }) : _react2.default.createElement(
        FilterDropdownMenuWrapper,
        { prefixCls: prefixCls, style: { width: column.filterWidth || 'auto' } },
        _react2.default.createElement(
          'ul',
          { className: prefixCls + '-dropdown-menu' },
          this.renderMenus(column.filters)
        ),
        _react2.default.createElement(
          'div',
          { className: prefixCls + '-filter-dropdown-btns' },
          multiple && _react2.default.createElement(
            'a',
            {
              className: prefixCls + '-filter-dropdown-link confirm',
              onClick: function onClick() {
                return _this4.handleConfirm(_this4.state.selectedKeys);
              }
            },
            locale.filterConfirm
          ),
          _react2.default.createElement(
            'a',
            {
              className: prefixCls + '-filter-dropdown-link clear',
              onClick: this.handleClearFilters
            },
            locale.filterReset
          )
        )
      );

      var dropdownSelectedClass = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, prefixCls + '-filter-selected', this.props.selectedKeys.length > 0 || column.filtered), _defineProperty(_classNames, '' + _data.IconPrefixCls, true), _defineProperty(_classNames, _data.IconPrefixCls + '-filter', true), _classNames));

      return _react2.default.createElement(
        'i',
        { title: locale.filterTitle, className: dropdownSelectedClass, onClick: this.onVisibleChange.bind(this, !visible), ref: 'container' },
        _react2.default.createElement(
          _trigger2.default,
          _extends({ ref: 'trigger', autoDestory: true, visible: visible, equalTargetWidth: false, getPopupContainer: getPopupContainer, target: this._getRootTarget }, column.triggerModel),
          menus
        )
      );
    }
  }]);

  return FilterMenu;
}(_react.Component), _class.propTypes = {
  locale: _propTypes2.default.any,
  selectedKeys: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
  column: _propTypes2.default.shape({
    filterWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    filterMultiple: _propTypes2.default.bool,
    allSelectable: _propTypes2.default.bool,
    filterDropdown: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
    filters: _propTypes2.default.array
  }),
  confirmFilter: _propTypes2.default.func,
  getPopupContainer: _propTypes2.default.func
}, _class.defaultProps = {
  handleFilter: function handleFilter() {},

  column: null,
  getPopupContainer: function getPopupContainer() {
    return document.body;
  }
}, _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.setSelectedKeys = function (key, e) {
    var selectedKeys = _this5.state.selectedKeys.slice() || [];
    var column = _this5.props.column;

    var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
    if (multiple) {
      var index = selectedKeys.indexOf(key);
      if (index === -1) {
        selectedKeys.push(key);
      } else {
        selectedKeys.splice(index, 1);
      }
    } else {
      selectedKeys = [key];
    }
    _this5.setState({ selectedKeys: selectedKeys }, function () {
      !multiple && _this5.handleConfirm();
    });
    e.stopPropagation();
  };

  this.handleClearFilters = function () {
    _this5.setState({
      selectedKeys: []
    }, function () {
      return _this5.handleConfirm([]);
    });
  };

  this.handleConfirm = function (selectedKeys) {
    _this5.setState({
      visible: false
    });
    _this5.confirmFilter(selectedKeys);
  };

  this.onVisibleChange = function (visible) {
    _this5.setState({
      visible: visible
    });
    if (!visible) {
      _this5.confirmFilter();
    }
  };

  this.handleMenuItemClick = function (key, e) {
    var keyPathOfSelectedItem = _this5.state.keyPathOfSelectedItem;
    if (keyPathOfSelectedItem[key]) {
      // deselect SubMenu child
      delete keyPathOfSelectedItem[key];
    } else {
      // select SubMenu child
      keyPathOfSelectedItem[key] = key;
    }
    _this5.setState({ keyPathOfSelectedItem: keyPathOfSelectedItem });
    e.stopPropagation();
  };

  this._getRootTarget = function () {
    return (0, _reactDom.findDOMNode)(_this5);
  };
}, _temp);
exports.default = FilterMenu;